<template>
  <div class="">
    <div class="fixed">
      <div class="top_header">
        <div class="m_flex_box flex_vc flex_jz">
          <div class="m_flex_box flex_vc">
            <van-icon name="arrow-left" class="mar_r" @click="$router.go(-1)"/>
            <div class="search_con_l m_flex_box flex_vc">
              <van-icon name="search" />
              <input class="middle" type="text" v-model="keyWord" placeholder="请输入您要搜索的项目名称"  @keyup.enter="submit"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed_pad"></div>
    <div class="score_main">
      <div class="inner m_flex_box flex_vc flex_jz">
        <div class="left m_flex_box flex_vc">
          <span>综合评定</span>
          <div class="m_flex_box">
            <img src="@/assets/img/star.png" alt="" @click="setScore(0, item)" v-for="(item) in zScore" :key="item">
            <img src="@/assets/img/star_.png" alt="" @click="setScore(0, zScore + item)" v-for="(item) in ( 5 - zScore)" :key="'#' + item">
          </div>
        </div>
        <i>{{zScore}}分</i>
      </div>
      <div class="inner m_flex_box flex_vc flex_jz">
        <div class="left m_flex_box flex_vc">
          <span>企业信誉</span>
          <div class="m_flex_box">
            <img src="@/assets/img/star.png" alt="" @click="setScore(1,item)" v-for="(item) in score1" :key="item">
            <img src="@/assets/img/star_.png" alt="" @click="setScore(1,score1 + item)" v-for="(item) in ( 5 - score1)" :key="'#' + item">
          </div>
        </div>
        <i>{{score1}}分</i>
      </div>
      <div class="inner m_flex_box flex_vc flex_jz">
        <div class="left m_flex_box flex_vc">
          <span>项目品质</span>
          <div class="m_flex_box">
            <img src="@/assets/img/star.png" alt="" @click="setScore(2, item)" v-for="(item) in score2" :key="item">
            <img src="@/assets/img/star_.png" alt="" @click="setScore(2, score2 + item)" v-for="(item) in ( 5 - score2)" :key="'#' + item">
          </div>
        </div>
        <i>{{score2}}分</i>
      </div>
      <div class="inner m_flex_box flex_vc flex_jz">
        <div class="left m_flex_box flex_vc">
          <span>楼盘质量</span>
          <div class="m_flex_box">
            <img src="@/assets/img/star.png" alt="" @click="setScore(3, item)" v-for="(item) in score3" :key="item">
            <img src="@/assets/img/star_.png" alt="" @click="setScore(3, score3 + item)" v-for="(item) in ( 5 - score3)" :key="'#' + item">
          </div>
        </div>
        <i>{{score3}}分</i>
      </div>
      <div class="inner m_flex_box flex_vc flex_jz">
        <div class="left m_flex_box flex_vc">
          <span>服务态度</span>
          <div class="m_flex_box">
            <img src="@/assets/img/star.png" alt="" @click="setScore(4, item)" v-for="(item) in score4" :key="item">
            <img src="@/assets/img/star_.png" alt="" @click="setScore(4, score4 + item)" v-for="(item) in ( 5 - score4)" :key="'#' + item">
          </div>
        </div>
        <i>{{score4}}分</i>
      </div>
    </div>
    <div class="text_con">
      <van-field
        v-model="comment"
        rows="4"
        type="textarea"
        maxlength="500"
        placeholder="关于这个楼盘有什么要评价的......"
        show-word-limit
      />
    </div>
    <div class="pic_con">
      <van-uploader v-model="fileList" :before-read="beforeRead" :max-count="4" />
    </div>
    <div class="btn_con">
      <div class="button" @click="submit">提交</div>
    </div>
    <van-overlay :show="Boolean(projectList.length)">
    </van-overlay>
    <div class="wrapper" v-show="projectList.length">
      <div class="select_con">
        <div class="m_flex_box flex_vc flex_jz row" v-for="(item, index) in projectList" :key="index">
          <p class="left line_comp1" @click="setVal(item.tgmc, item.itemId)">{{item.tgmc}}({{item.xmmc}})</p>
        </div>
      </div>
    </div>
    <img class="to_home" @click="$router.replace('/mine')" src="@/assets/img/index/99.png" alt="">
  </div>
</template>

<script>
import qs from 'qs'
import topHeader from '@/components/header'
export default {
  data() {
    return {
      comment: '',
      fileList: [],
      image1: '',
      image2: '',
      image3: '',
      image4: '',
      zScore: 0,
      score1: 0,
      score2: 0,
      score3: 0,
      score4: 0,
      flag: true,
      itemId: '',
      keyWord: '',
      projectList: [],
      jsonArr: [],
      showProject:'',
    };
  },
  components: {
    topHeader,
  },
  watch: {
    keyWord(n) {
      this.$set(this, 'projectList', [])
      const newArr = []
      this.jsonArr.forEach(function (item) {
        if ((item.tgmc.includes(n)|| item.xmmc.includes(n))) {
          newArr.push(item)
        }
      })
      this.$set(this, 'projectList', newArr);
      if(n === '') {
        this.$set(this, 'projectList', [])
      }
    }
  },
  mounted() {
    this.getProjectName()
  },
  methods: {
    setVal(mc, id) {
      this.keyWord = mc;
      this.itemId = id;
      this.$nextTick(() => {
        this.$set(this, 'projectList', [])
      })
    },
    getProjectName() {
      this.$new.post('/itemInfo/getItemSearch.do').then(res => {
        this.jsonArr = res.obj
      })
    },
    beforeRead(file) {
      if (file.type.toLowerCase() !== 'image/jpg' && file.type.toLowerCase() !== 'image/png' && file.type.toLowerCase() !== 'image/jpeg' && file.type.toLowerCase() !== 'image/gif') {
        this.$toast('该格式不支持');
        return false;
      } else if (file.size > 5000 * 1024) {
        this.$toast('文件大小不得超过5M');
        return false;
      }
      return true;
    },
    setScore(type, score) {
      if(type) {
        this['score' + type] = score
      } else {
        this.zScore = score
      }
    },
    submit() {
      if(!this.keyWord) {
        this.$toast('请输入项目名称')
        return;
      }
      if(!this.zScore) {
        this.$toast('请对综合评定进行评分')
        return;
      } else if (!this.score1) {
        this.$toast('请对企业信誉进行评分')
        return;
      } else if (!this.score2) {
        this.$toast('请对项目品质进行评分')
        return;
      } else if (!this.score3) {
        this.$toast('请对楼盘质量进行评分')
        return;
      } else if (!this.score4) {
        this.$toast('请对服务态度进行评分')
        return;
      } else if (!this.comment) {
        this.$toast('请输入点评')
        return;
      }
      if(!this.flag) {
        return
      }
      this.flag = false
      const formData = new FormData();
      this.fileList.forEach((item ,index) => {
        formData.append("image" + (index + 1), item.file);
      });
      formData.append("zScore", this.zScore);
      formData.append("score1", this.score1);
      formData.append("score2", this.score2);
      formData.append("score3", this.score3);
      formData.append("score4", this.score4);
      formData.append("comment", this.comment);
      formData.append("itemId", this.itemId);
      this.$http({
        url: 'cms/xzhouse/reg/addComment.do',
        method: 'POST',
        headers: {
          'Content-Type': 'application'
        },
        data: formData
      }).then(res => {
        this.flag = true
        if(res.success) {
          this.$toast('评论成功')
        } else {
          this.$toast(res.msg);
        }
      }).catch(() => {
        this.flag = true
      })
    }
  },
};
</script>
<style lang="less" scoped>
  .fixed_pad{
    padding-top: 1.1rem;
  }
  .top_header{
    height: 0.7rem;
    padding: 0.2rem 0rem;
    width: 7.04rem;
    margin: 0 auto;
    &.top_sm{
      padding: 0.1rem;
    }
    .search_con, .search_con_l{
      background-color: #F6F6F6;
      border: 1px solid #f0f0f0;
      border-radius: 0.7rem;
      height: 0.7rem;
      box-sizing: border-box;
      font-size: 0.26rem;
      padding: 0 0.3rem;
      color: #303030;
      i{
        font-size: 0.36rem;
        margin-right: 0.2rem;
      }
    }
    input{
      width: 80%;
      height: 0.7rem;
      background-color: transparent;
    }
    .search_con_l{
      width: 5.72rem;
    }
    .to_map{
      font-size: 0.28rem;
      img{
        margin-right: 0.06rem;
        width: 0.32rem;
        height: 0.32rem;
      }
    }
  }
  .header_icon{
    font-size: 0.42rem;
  }
  .fixed{
    background-color: #fff;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 10;
  }
  .van-icon-arrow-left{
    font-size: 0.32rem;
    &.mar_r{
      margin-right: 0.18rem;
    }
  }
  .search_con_l{
    width: 5.72rem;
  }
  .top_con{
    width: 7.04rem;
    margin: 0 auto;
    border-bottom: 1px solid #f5f5f5;
    padding: 0.3rem 0;
    >img{
      width: 1.52rem;
      height: 1.14rem;
      margin-right: 0.35rem;
    }
    .info_con{
      width: 5rem;
      h4{
        font-size: 0.3rem;
        height: 0.7rem;
      }
      p{
        color: #FF2A2A;
        font-size: 0.22rem;
        span{
          font-weight: 800;
          font-size: 0.32rem;
        }
      }
      .score_con{
        margin-top: 0.02rem;
        img{
          width: 0.26rem;
          height: 0.26rem;
          margin-left: 0.08rem;
          display: block;
        }
      }
    }
  }
  .score_main{
    width: 7.04rem;
    margin: 0 auto;
    padding: 0.46rem 0;
    .inner{
      margin-bottom: 0.24rem;
      &:last-child{
        margin-bottom: 0;
      }
      .left{
        font-size: 0.28rem;
        color: #909090;
        span{
          margin-right: 0.28rem;
        }
        img{
          margin-right: 0.18rem;
        }
      }
      i{
        font-size: 0.28rem;
        color: #FF2A2A;
        padding-right: 0.42rem;
      }
    }
  }
  .text_con{
    width: 7.04rem;
    margin: 0 auto;
    border: 1px solid #f5f5f5
  }
  .pic_con{
    width: 7.04rem;
    margin: 0rem auto 0.6rem;
    padding: 0.3rem 0;
    border-bottom: 1px solid #f5f5f5;
  }
  .btn_con{
    padding-bottom: 0.4rem;
  }
  .button{
    background-color: #2F72F5;
    color: #fff;
    border-radius: 0.08rem;
    text-align: center;
    line-height: 0.74rem;
    width: 7.04rem;
    margin: 0 auto;
    font-size: 0.28rem;
  }
  .select_con{
    z-index: 9;
    position: fixed;
    top: 1.1rem;
    background-color: #fff;
    left: 0;
    right: 0;
    height: 60vh;
    overflow: auto;
    padding: 0.23rem;
    font-size: 0.26rem;
    .row{
      height: 0.8rem;
      border-bottom: 1px solid #f5f5f5;
      p{
        font-size: #303030;
      }
      span, i{
        color: #A0A0A0;
        font-size: 0.24rem;
      }
      .left{
        width: 82%;
      }
    }
  }
</style>